import { selectApiData } from 'util/selector/apiSelector';

import { WithData } from 'api/interfaces';
import { AxiosInstance } from 'axios';
import { ProjectModel } from 'api/dto/Project.dto';

import {
  mapPulseTemplateDtoToModel,
  PulseTemplateDto,
  PulseTemplateModel,
} from './dto/PulseTemplate.dto';

export class DemandPollApi {
  constructor(private apiClient: AxiosInstance) {}

  create(id: number, project: ProjectModel): Promise<PulseTemplateModel> {
    return this.apiClient
      .post<WithData<PulseTemplateDto>>(`/api/v1/pulse-template/${id}/on-demand`, project)
      .then(selectApiData)
      .then(mapPulseTemplateDtoToModel);
  }
}
